import { createContext } from 'react';
import { DEFAULT_LOCALE } from '../constants';
export const ShopifyContext = createContext(null);
/* this can be move into ShopifyProvider once ShopifyContext can be use in RSC again */
export function makeShopifyContext(shopifyConfig) {
    var _a, _b;
    return {
        locale: (_a = shopifyConfig.defaultLocale) !== null && _a !== void 0 ? _a : DEFAULT_LOCALE,
        storeDomain: (_b = shopifyConfig === null || shopifyConfig === void 0 ? void 0 : shopifyConfig.storeDomain) === null || _b === void 0 ? void 0 : _b.replace(/^https?:\/\//, ''),
        storefrontToken: shopifyConfig.storefrontToken,
        storefrontApiVersion: shopifyConfig.storefrontApiVersion,
    };
}
